

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";

const productionDataAtom = atom({key:'productionAtomData', default:{production_info:[],
    production_setup_info:[], warehouse_info:[]}});
const productionEdit = atom({key:'productionEdit', default:{itemList:[]}});

export  const SetProductionAtomData = () => useSetRecoilState(productionDataAtom);
export  const GetProductionAtomData = () => useRecoilValue(productionDataAtom);
export const ResetProductionAtomData = ()=> useResetRecoilState(productionDataAtom);

export  const SetProductionEdit = () => useSetRecoilState(productionEdit);
export  const GetProductionEdit = () => useRecoilValue(productionEdit);
export const ResetProductionEdit = ()=> useResetRecoilState(productionEdit);
